import React, { Component, Fragment, useEffect } from 'react';
//import { render } from 'react-dom';
//import Hello from './Hello';
import './style.css';
import '../assets/css/formulario.css'
import Swal from 'sweetalert2';
import Loading from "react-fullscreen-loading";
import ReCAPTCHA from 'react-google-recaptcha';

export class TerminosCondicionesCibb extends Component {

    constructor(props) {
        super(props);
    }

    render() {

        return (
            <div>Términos CIBB</div>
        )
    }
}

export default TerminosCondicionesCibb;


export function TratamientoDatosCibbString() {
    return (
        `
    <div class=WordSection1 style='text-align:left;margin:15px'>
        <p style='font-size:20.0pt;text-align:center;mso-margin-bottom-alt:auto;line-height:normal;
        background:white'><strong>Aviso Legal de Tratamiento de Datos</strong></p>
        <p style='mso-margin-bottom-alt:auto;line-height:normal;
        background:white'>Al completar y enviar este formulario, usted consiente que la ESPOL utilice sus datos
        personales para contactarlo y brindarle mayor información sobre el congreso seleccionado,
        y para informarle sobre futuros congresos que podrían ser de
        su interés. Además, le informamos que esta información puede ser compartida con las
        empresas y fundaciones de la ESPOL, con el objetivo de cumplir con la finalidad
        mencionada anteriormente. Su información no será utilizada para otros fines no declarados.</p>
    </div>
        `
    )
}
